import { useEffect, useState } from 'react'

import { useInBackgroundChange } from './useInBackgroundChange'

export const useTimerCallback = (callback: () => void, delay: number, active = true) => {
  const [id, setId] = useState<number>()
  const inBackground = useInBackgroundChange()

  const setup = () => {
    if (delay > 0 && active && !inBackground) {
      if (id) {
        window.clearTimeout(id)
      }

      console.log('setting timer....')
      const tId = window.setTimeout(() => {
        console.log('calling timer....')

        callback()

        setId(undefined)
      }, delay)

      setId(tId)
    }
  }

  useEffect(() => {
    if (!id) {
      setup()
    }

    return () => {
      window.clearTimeout(id)
    }
  }, [delay, active, id])

  useEffect(() => {
    if (inBackground && id) {
      setId(undefined)
      window.clearTimeout(id)
      console.log('Clearing timer due to backgrounding....')
    } else if (!inBackground && !id) {
      console.log('Setting up timer due to return....')

      setup()
    }
  }, [inBackground])
}
